import React, { useState } from 'react';

import { ReactComponent as LeftArrow } from '@assets/icons/crm/leftArrrow.svg';
import { ReactComponent as RightArrow } from '@assets/icons/crm/rightArrow.svg';

const HorizontalScroll = ({ elementReference }) => {
	const [arrowDisable, setArrowDisable] = useState(true);

	const handleHorizontalScroll = (element, speed, distance, step) => {
		if (element) {
			let scrollAmount = 0;
			const slideTimer = setInterval(() => {
				element.scrollLeft += step;
				scrollAmount += Math.abs(step);
				if (scrollAmount >= distance) {
					clearInterval(slideTimer);
				}
				if (element.scrollLeft === 0) {
					setArrowDisable(true);
				} else {
					setArrowDisable(false);
				}
			}, speed);
		}
	};

	return (
		<div className="scroll-table-buttons">
			<button
				className="left"
				disabled={arrowDisable}
				onClick={() => {
					handleHorizontalScroll(elementReference, 25, 100, -400);
				}}
			>
				<LeftArrow />
			</button>
			&nbsp;&nbsp;
			<button
				className="right"
				onClick={() => {
					handleHorizontalScroll(elementReference, 25, 100, 400);
				}}
			>
				<RightArrow />
			</button>
		</div>
	);
};

export default HorizontalScroll;
